export const parsePx = (px) => {
  const num = Number.parseFloat(px);
  return Number.isFinite(num) ? num : 0;
};
